
<template>
    <div>
        <Alert type="error">UTC时间每天上午9:00更新</Alert>
        <compWrapper title="总库容(CBM)" theme="primary" >
            <Table
                class="margin-15"
                :columns="allcolumns"
                :data="alldataList"
                size="small"></Table>
        </compWrapper>
        <compWrapper title="期初使用库容(CBM)" theme="info" >
            <Table
                class="margin-15"
                :columns="allcolumns"
                :data="earlydataList"
                size="small"></Table>
        </compWrapper>
        <compWrapper title="预计入库" theme="warning" >
            <Table
                class="margin-15"
                :columns="inputcolumns"
                :data="inputdataList"
                size="small"></Table>
        </compWrapper>
        <compWrapper title="预计出库" theme="success" >
            <Table
                class="margin-15"
                :columns="inputcolumns"
                :data="outdataList"
                size="small"></Table>
        </compWrapper>
        <compWrapper title="期末库容使用(CBM)" theme="primary" >
            <Table
                class="margin-15"
                :columns="allcolumns"
                :data="enddataList"
                size="small"></Table>
        </compWrapper>
        <compWrapper title="剩余可用库容(CBM)--负数表示库容缺口" theme="error" >
            <Table
                class="margin-15"
                :columns="allcolumns"
                :data="remaindataList"
                size="small"></Table>
        </compWrapper>
        <!-- 折线图 -->
        <div class="margin-top-15 bg-fff" style="position: relative;">
            <div id="pictureImg1" style="height: 400px;width:100%;padding:15px"></div>
            <Spin fix v-if="loading1"></Spin>
        </div>
    </div>
</template>

<script>
import { HttpGetChartData } from '@/service/report';
export default {
    data(){
        return {
            allcolumns:[
                {                    
                    title: '区域',                       
                    key: 'area_name'                   
                }  
            ],
            inputcolumns:[
                {                    
                    title: '区域',                       
                    key: 'area_name'                   
                } 
            ],
            alldataList:[],
            earlydataList:[],
            inputdataList:[],
            outdataList:[],
            enddataList:[],
            remaindataList:[],
            loading1:false,
        }
    },
    created(){
        this.update();
    },
    methods:{
        async update(){
            // 第一个看板
            await HttpGetChartData({
                component_id:37,
                args:JSON.stringify({orgId:global.SYSID}),
            }).then(res=>{
                let arrMonths1 = [];
                arrMonths1 = res.data.data[0].alldate.split(',');

                let renderDataList1 = this.handleDataColumns(res.data.data,'area_name','months','CBM')
                // table数据重新加载
                this.renderAllColumns(arrMonths1,this.allcolumns)
                this.alldataList = renderDataList1;
                this.alldataList.sort(function(a,b){
                    return a.area_name.localeCompare(b.area_name)
                })
            })

            // 第二个看板
            await HttpGetChartData({
                component_id:38,
                args:JSON.stringify({orgId:global.SYSID}),
            }).then(res=>{
                let renderDataList2 = this.handleDataColumns(res.data.data,'area_name','months','CBM')
                // table数据重新加载
                this.earlydataList = renderDataList2;
                this.earlydataList.sort(function(a,b){
                    return a.area_name.localeCompare(b.area_name)
                })
            })

            // 第三个看板
            await HttpGetChartData({
                component_id:39,
                args:JSON.stringify({orgId:global.SYSID}),
            }).then(res=>{
                let renderDataList3 = this.handleDataColumns(res.data.data,'area_name','months','CBM',' (入库库容CBM)')
                let renderDataList4 = this.handleDataColumns(res.data.data,'area_name','months','QTY',' (入库柜量QTY(cbm/65))')
                
                this.inputdataList = [...renderDataList3,...renderDataList4]
                this.inputdataList.sort(function(a,b){
                    return a.area_name.localeCompare(b.area_name)
                })

            })

            // 第四个看板
            await HttpGetChartData({
                component_id:40,
                args:JSON.stringify({orgId:global.SYSID}),
            }).then(res=>{
                let arrMonths1 = [];
                arrMonths1 = res.data.data[0].alldate.split(',');
                this.renderAllColumns(arrMonths1,this.inputcolumns);

                let renderDataList3 = this.handleDataColumns(res.data.data,'area_name','months','CBM',' (入库库容CBM)')
                let renderDataList4 = this.handleDataColumns(res.data.data,'area_name','months','QTY',' (入库柜量QTY(cbm/65))')
                
                this.outdataList = [...renderDataList3,...renderDataList4]
                this.outdataList.sort(function(a,b){
                    return a.area_name.localeCompare(b.area_name)
                })
            })

            // 第五个看板
            await HttpGetChartData({
                component_id:41,
                args:JSON.stringify({orgId:global.SYSID}),
            }).then(res=>{
                let renderDataList2 = this.handleDataColumns(res.data.data,'area_name','months','CBM')
                // table数据重新加载
                this.enddataList = renderDataList2;
                this.enddataList.sort(function(a,b){
                    return a.area_name.localeCompare(b.area_name)
                })
            })

            // 第六个看板
            await HttpGetChartData({
                component_id:42,
                args:JSON.stringify({orgId:global.SYSID}),
            }).then(res=>{
                let renderDataList2 = this.handleDataColumns(res.data.data,'area_name','months','CBM')
                // table数据重新加载
                this.remaindataList = renderDataList2;
                this.remaindataList.sort(function(a,b){
                    return a.area_name.localeCompare(b.area_name)
                })
                let seriesData = [];
                this.remaindataList.map(item=>{
                    let arr = [];
                    for(let key in item){
                        if(key !='area_name'){
                            arr.push(item[key])
                        }
                    }
                    let json = {
                        name:item.area_name,
                        type: 'line',
                        smooth: true,
                        data:arr
                    }
                    seriesData.push(json)
                })
                // 画图所需的变量
                let allorderDates = res.data.data[0].alldate.split(',');

                this.getImg(allorderDates,seriesData);
            })

            // 画折线图
        },
        // table重新渲染标题
        renderAllColumns(arrMonths,array){
            arrMonths.map(item=>{
                array.push({
                    title:item,
                    key:item
                })
            })
            
        },
        // 获取单个对应字段的组合
        handleDataColumns(resData,titlename,columnKey,columnVal,suffixName){
            let arrName = [],renderDataList=[];
            arrName = resData.map(item=> item[titlename])
            let nameSet = new Set(arrName);
            for(let key of nameSet){
                let json = {}
                resData.map(item=>{
                    if(key == item[titlename]){
                        json[titlename] = item[titlename]+(suffixName||'')
                        json[item[columnKey]] = item[columnVal].toFixed(2)
                    }
                })
                renderDataList.push(json)
            }
            return renderDataList
        },
        getImg(allorderDates,seriesData){
            var colors = ['#B91F26','#246770','#FCC712','#E57022','#ACBB2E','#FE7858','#91C358','#F9D258','#E57022'];
            let lineReserveGraph = Echarts.init(document.getElementById('pictureImg1'));
            // 绘制图表
            lineReserveGraph.setOption({
                title : {
                    text: '各区域缺口CBM',
                    x:'center',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow'
                    }
                },
                legend: {
                    bottom:0
                },
                grid: {
                    top:'15%',
                    left: '3%',
                    right: '3%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: [
                    {
                    type: 'category',
                    data: allorderDates
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        splitNumber: 3,
                    },
                    {
                        type: 'value',
                        name: '%',
                        nameTextStyle: {
                            color: '#ccc',
                            padding: [0, 0, 10, -30]
                        },
                        splitNumber: 3,
                    }
                ],
                color:colors,
                series: seriesData
            })
            // 处理浏览器窗口缩放问题
            window.addEventListener("resize", () => {
                if(lineReserveGraph){
                    lineReserveGraph.resize()
                }
            })
        },
    },
}
</script>

